import React from "react";

const Footer = ({ children }) => {
  return <div>{children}</div>;
};

export default Footer;
